<mat-card class="chargepoint-card" [ngClass]="{'hide-actions': hideActions}">
  <mat-card-content>
    <div class="grid-container">
      <div class="icon-section-container">
        <div class="icon-section">
          <mat-icon *ngIf="chargepoint?.type === 'OCPP'">ev_station</mat-icon>
          <mat-icon *ngIf="chargepoint?.type === 'OKECHARGE'">outlet</mat-icon>
          <mat-icon *ngIf="chargepoint?.type === 'IVY'">outlet</mat-icon>
          <mat-icon *ngIf="chargepoint?.type === 'NETATMO'">outlet</mat-icon>
          <span class="type-label">{{chargepoint?.type || 'Unknown'}}</span>
        </div>
        <div class="icon-section-name chargepoint-name" [matTooltip]="getChargepointName()">
          {{ getChargepointName() }}
        </div>
      </div>

      <div class="status-section">
        <h3 class="status-section-name chargepoint-name" [matTooltip]="getChargepointName()">
          {{ getChargepointName() }}
        </h3>
        <div class="status-line">
          <app-chargepoint-status [status]="chargepoint?.status"></app-chargepoint-status>
          <app-last-heartbeat-info [chargepoint]="chargepoint"></app-last-heartbeat-info>
        </div>
      </div>

      <div class="info-section">
        <app-ocpp-vendor-info *ngIf="chargepoint?.type === 'OCPP'" [chargepoint]="$any(chargepoint)"></app-ocpp-vendor-info>
        <app-okecharge-vendor-info *ngIf="chargepoint?.type === 'OKECHARGE'" [chargepoint]="$any(chargepoint)"></app-okecharge-vendor-info>
        <app-ivy-vendor-info *ngIf="chargepoint?.type === 'IVY'" [chargepoint]="$any(chargepoint)"></app-ivy-vendor-info>
      </div>

      <div class="other-section" *ngIf="!hideActions"></div>

      <div class="actions-section" *ngIf="!hideActions">
        <span matTooltip="Not available because not implemented yet">
          <button mat-icon-button color="primary" aria-label="Start charging" [disabled]="true || chargepoint?.status !== 'AVAILABLE'">
            <mat-icon>play_arrow</mat-icon>
          </button>
        </span>
        <button
          mat-icon-button
          color="primary"
          matTooltip="Manage configurations"
          (click)="showChangeConfigurationDialog()">
          <mat-icon>tune</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          matTooltip="View logs"
          (click)="showLogsDialog()">
          <mat-icon>article</mat-icon>
        </button>
        <button mat-icon-button color="primary" matTooltip="Open chargepoint page" (click)="goToChargepointClick.emit()">
          <mat-icon>search</mat-icon>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
